/* eslint-disable security/detect-object-injection */
import Logger from './LoggerCustom';
import { makeRedirection } from './redirection';
import {
  trackAction,
  sendGoogleAnalyticsTrack,
  sendMelidataTrack,
} from './tracking';
import { IMAGES } from '../app/constants/images';

const { MP_DEFAULT_THEME, MP_YELLOW_THEME } = IMAGES.PREFIX;

const isObject = data => data !== null && typeof data === 'object';

const isArray = data => data !== null && typeof data === 'object' && data.constructor === Array;

const snakeCaseToCamelCase = string => string.replace(/(_(\w))/g, (match, p1, p2) => p2.toUpperCase());

const transformKeysToCamelCase = (data) => {
  if (isArray(data)) {
    return data.map(item => transformKeysToCamelCase(item));
  }

  if (isObject(data)) {
    const newObject = {};

    Object.keys(data).forEach((key) => {
      newObject[snakeCaseToCamelCase(key)] = transformKeysToCamelCase(data[key]);
    });

    return newObject;
  }

  return data;
};

const getSlides = (acc, cur, slidesPerView) => {
  if (!Array.isArray(acc) || !Array.isArray(cur) || !slidesPerView) {
    return [];
  }
  if (cur.length) {
    acc.push(cur.slice(0, slidesPerView));
    getSlides(acc, cur.slice(slidesPerView, cur.length), slidesPerView);
  }

  return acc;
};
const transformUrl = string => string.replace(/\/[^/]+$/, '');

const getImagesPrefix = ({ isYellowTheme, configPrefix }) => {
  if (isYellowTheme) {
    return `${configPrefix}${MP_YELLOW_THEME}`;
  }
  return `${configPrefix}${MP_DEFAULT_THEME}`;
};

const camelCaseToSnakeCase = (key) => key.replace(/([A-Z])/g, '_$1').toLowerCase();

const transformKeysToSnakeCase = (data) => {
  if (Array.isArray(data)) {
    return data.map(transformKeysToSnakeCase);
  }

  if (data !== null && typeof data === 'object') {
    return Object.keys(data).reduce((acc, key) => {
      acc[camelCaseToSnakeCase(key)] = transformKeysToSnakeCase(data[key]);
      return acc;
    }, {});
  }

  return data;
};

export {
  transformKeysToCamelCase,
  transformKeysToSnakeCase,
  snakeCaseToCamelCase,
  camelCaseToSnakeCase,
  isObject,
  isArray,
  getSlides,
  transformUrl,
  Logger,
  makeRedirection,
  trackAction,
  sendGoogleAnalyticsTrack,
  sendMelidataTrack,
  getImagesPrefix,
};
